import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Select from 'react-select';

import { messages } from '../../../../../../_shared/i18n/messages';

const propTypes = {

	/**
	 * Set of merge tags that are available for use.
	 */
	mergeTags: PropTypes.shape({

		organization: PropTypes.shape({

			domain: PropTypes.bool,

		}),

		invitation: PropTypes.shape({

			id: PropTypes.bool,

		}),

	}),

	/**
	 * React ref for Select component.
	 */
	selectRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),

	/**
	 * Callback function to handle select change events.
	 */
	onChange: PropTypes.func.isRequired,

};

const MergeTagSelect = (props) => {

	const { mergeTags, selectRef } = props;

	const intl = useIntl();

	const mergeTagOptions = [];

	Object.keys(mergeTags).forEach((key) => {

		const keyValue = mergeTags[key];

		if (typeof keyValue === 'object') {

			const groupOption = {
				label: key,
				options: [],
			};

			Object.keys(keyValue).forEach((mergeTag) => {

				groupOption.options.push({
					label: mergeTag,
					value: `{{${key}.${mergeTag}}}`,
				});

			});

			mergeTagOptions.push(groupOption);

		} else if (typeof keyValue === 'string') {

			mergeTagOptions.push({
				label: key,
				value: `{{${key}}}`,
			});

		}

	});

	return (
		<Select
			ref={selectRef}
			styles={{
				control: (styles) => {
					return Object.assign({}, styles, {
						// Hide the react-select input
						display: 'none',
					});
				},
				container: (styles) => {
					return Object.assign({}, styles, {
						// Make sure a width is set on the select menu
						width: '100%',
					});
				},
				menu: (styles) => {
					return Object.assign({}, styles, {
						margin: 0,
					});
				},
				menuList: (styles) => {
					return Object.assign({}, styles, {
						maxHeight: '300px',
					});
				},
				option: (styles) => {
					return Object.assign({}, styles, {
						cursor: 'pointer',
					});
				},
			}}
			noOptionsMessage={
				() => intl.formatMessage(messages.TC_COMPONENTS_TEXT_EDITOR_MENTION_DROPDOWN_EMPTY_STATE)
			}
			options={mergeTagOptions}
			menuIsOpen
			{...props} />
	);

};

MergeTagSelect.propTypes = propTypes;

export default MergeTagSelect;
